<script>
  import { Link } from "svelte-navigator";
  import { onMount } from "svelte";
  import Button from '../components/Button.svelte';
  import Modal from '../components/Modal.svelte';
  import ArrowRight from "../assets/images/icon-arrow-right.svelte";
  import InfoIcon from "../assets/images/icon-info.svelte";
  import Fer from "../Fer.js";

  let isShownInfo;
  const setIsShownInfo = bool => {
    isShownInfo = bool;
  };
  const touch = () => {
    if (isShownInfo) {
      setIsShownInfo(false);
    } else {
      setIsShownInfo(true);
    }
  };

  let video_input;
  let animApi;
  let pump_elem;
  let pump_anim;
  let tree_elem;
  let tree_anim;
  let bush_elem;
  let bush_anim;
  let fer;
  const bush_anim_start = 38;

  let gameStarted = false;
  let introModalVisible = true;
  let outroModalVisible = false;

  // game
  // constants
  const pump_step = 150;
  const pump_min = 0;
  const pump_max = 100;

  const bucket_step = 50;
  const bucket_min = 0;
  const bucket_max = 100;

  const flowing_false = 0;
  const flowing_true = 50;

  let faceControl = "neutral"

  let pumpslider = pump_min;
  let bucketslider = bucket_min;
  let flowing = flowing_false;

  // timings
  let last_frame = 0;
  let every_x_frame = 2;
  let framerate_count = 0;
  const delta_m = 50

  function updateLoop() {
    if (gameStarted) {
      const this_frame = performance.now() / 1000;
      const dt = this_frame - last_frame
      last_frame = this_frame

      // change variables according to control
      // control pump with 'A' and 'S'
      if (faceControl === 'disgust') {
        // handle moves down and water is flowing
        pumpslider -= dt * pump_step;
        if (pumpslider <= pump_min) {
          // handle cannot move further down
          pumpslider = pump_min;
          flowing = flowing_false;
        } else {
          // handle moves, water runs, bucket fills
          bucketslider += dt * bucket_step;
          flowing = flowing_true;
          if (bucketslider >= bucket_max) {
            // bucket full
            bucketslider = bucket_max;
          }
        }
      } else if (faceControl === 'smile') {
        // handle moves up and water is NOT flowing
        pumpslider += dt * pump_step;
        flowing = flowing_false;
        if (pumpslider >= pump_max) {
          // handle cannot move further up
          pumpslider = pump_max;
        }
      } else if (faceControl === 'surprised') {
        bucketslider -= dt * bucket_step;
        flowing = flowing_false;

        if (bucketslider <= bucket_min) {
          bucketslider = bucket_min;
          // Tree is not Growing
          tree_anim.pause();
          bush_anim.pause();
        } else {
          // Tree is Growing
          tree_anim.play();
          bush_anim.play();
        }
      } else {
        flowing = flowing_false;
      }

      if (!(faceControl === 'surprised')) {
        // Tree is not Growing
        tree_anim.pause();
        bush_anim.pause();
      }
    }
    requestAnimationFrame(updateLoop);
  }

  const complete = () => {
    outroModalVisible = true;
    gameStarted = false;
  };

  function animloaded(e) {
    console.log("loaded");

    animApi = lottie_api.createAnimationApi(pump_anim);
    let pump = animApi.getKeyPath("PumpSlider,Transform,X Position");
    let bucket = animApi.getKeyPath("BucketSlider,Transform,X Position");
    let stream = animApi.getKeyPath("StreamSlider,Transform,X Position");
    animApi.addValueCallback(pump, function(currentValue) {
      return pumpslider;
    });
    animApi.addValueCallback(bucket, function(currentValue) {
      return bucketslider;
    });
    animApi.addValueCallback(stream, function(currentValue) {
      return flowing;
    });
  }

  const startGame = () => {
    gameStarted = true;
    introModalVisible = false;
    outroModalVisible = false;
  };

  const playAgain = () => {
    tree_anim.goToAndStop(0, true);
    bush_anim.goToAndStop(bush_anim_start, true);
    bucketslider = bucket_min;
    startGame();
  };
  
  onMount(() => {
    const cam = new Camera(video_input, {
      facingMode: 'user',
      width: 1280,
      height: 720,
      onFrame: async () => {
        if(framerate_count % every_x_frame == 0) {
          faceControl = await fer.getExpression(video_input, 1280, 720)
        }

        framerate_count += 1;
      }
    });

    fer = Fer.getInstance()
    fer.setupTf().then(() => {
      cam.start()
    })

    tree_anim = lottie.loadAnimation({
      container: tree_elem,
      path: "/lotties/tree.json",
      renderer: "svg",
      loop: false,
      autoplay: false,
    });
    tree_anim.setSpeed(1.25);

    bush_anim = lottie.loadAnimation({
      container: bush_elem,
      path: "/lotties/bush_long.json",
      renderer: "svg",
      loop: false,
      autoplay: false,
    });
    bush_anim.goToAndStop(bush_anim_start, true);
    bush_anim.setSpeed(1.00);

    pump_anim = lottie.loadAnimation({
      container: pump_elem,
      path: "/lotties/pump.json",
      renderer: "svg",
      loop: true,
      autoplay: true
    });    

    pump_anim.addEventListener("DOMLoaded", animloaded);
    tree_anim.addEventListener("complete", complete);
    updateLoop();
  });
</script>

<div class='waterpump'>
  <main class='waterpump__main'>
    <div class='waterpump__bush' bind:this={bush_elem}>
    </div>
    <div class='waterpump__wrapper'>
      <div class='waterpump__wrapper--pump'>
        <div bind:this={pump_elem}></div>
      </div>
      <div class='waterpump__wrapper--tree'>
        <div bind:this={tree_elem}></div>
      </div>
    </div>
    <div class='game__confetti'></div>
  </main>
  <footer class='waterpump__footer'>
    <div class='waterpump__footer--camera'>
      <div class='cam'>
        <video
          class='camera'
          style="transform: scaleX(-1);"
          bind:this={video_input}
        >
          <track kind="captions" srclang="en" label="english_captions">
        </video>
      </div>
    </div>
    <div class='info__expression flex flex-ai-c scale'>
      <img src='/emojis/smile.png' alt='Smile emoji' />
      <div class='info__expression--text  '>
        <h5>SMILE</h5>
        <h2>to Pump Up</h2>
      </div>
    </div>
    <div class='info__expression flex flex-ai-c scale'>
      <img src='/emojis/disgust.png' alt='Disgust emoji' />
      <div class='info__expression--text'>
        <h5>DISGUST</h5>
        <h2>to Pump Down</h2>
      </div>
    </div>
    <div class='info__expression flex flex-ai-c scale'>
      <img src='/emojis/surprise.png' alt='Surprise emoji' />
      <div class='info__expression--text  '>
        <h5>SURPRISE</h5>
        <h2>to Water Garden</h2>
      </div>
    </div>
    <div class='game__footer--score'>
      <span></span>
    </div>
  </footer>
  <Link to='/games'>
    <button class='btn-arrow'>
      <ArrowRight />
    </button>
  </Link>  
  <button
    on:mouseleave={() => setIsShownInfo(false)}
    on:mouseenter={() => setIsShownInfo(true)}
    on:touchstart={() => touch()}
    class='btn-info'
  >
    <InfoIcon />
  </button>

  {#if introModalVisible}
    <Modal hasHeader={true}>
      <div slot="header">Task</div>
      <div class="flowers__modaltext" slot="content">
        <h4>Pump water and make the garden grow</h4>
      </div>
      <div class="flowers__hero--btn" slot="buttons">
        <Button
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
          on:click={() => startGame()}
        >
          PLAY
        </Button>
      </div>
    </Modal>
  {/if}

  {#if outroModalVisible}
    <Modal hasHeader={true}>
      <div slot="header">Task Complete</div>
      <div class="flowers__modaltext" slot="content">
        <h4>TREE-mendous!</h4>
      </div>
      <div class="flowers__hero--btn" slot="buttons">
        <Button
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
          on:click={() => playAgain()}
        >
          PLAY AGAIN
        </Button>
        <Link to="/games">
          <Button
            buttonSize="btn--xlarge"
            buttonStyle="btn--primary--solid"
          >
            MENU
          </Button>
        </Link>
      </div>
    </Modal>
  {/if}

  <div>
    {#if isShownInfo}
      <div class='info'>
        <h4>Pump water and make the garden grow</h4>
        <div class='info__expression flex flex-ai-c '>
          <img src='/emojis/smile.png' alt='Smile emoji' />
          <div class='info__expression--text  '>
            <h5>SMILE</h5>
            <h2>to Pump Up</h2>
          </div>
        </div>
        <div class='info__expression flex flex-ai-c '>
          <img src='/emojis/disgust.png' alt='Disgust emoji' />
          <div class='info__expression--text'>
            <h5>DISGUST</h5>
            <h2>to Pump Down</h2>
          </div>
        </div>
        <div class='info__expression flex flex-ai-c '>
          <img src='/emojis/surprise.png' alt='Surprise emoji' />
          <div class='info__expression--text  '>
            <h5>SURPRISE</h5>
            <h2>to Water Garden</h2>
          </div>
        </div>        
        <p> <strong>Note:</strong> The facial detection is not perfect. Play in good lighting conditions and try with variations of your facial expressions :-)</p>
      </div>
    {/if}
  </div>
</div>